import useFetchEntity from 'hooks/useFetchEntity';
import useOrganization from 'hooks/useOrganization';
import { useEffect } from 'react';
import useLoginStore from 'store/loginStore';
import useRequiredActionsStore from 'store/requiredActionsStore';

const useRequiredActions = () => {
  const currentUser = useLoginStore(s => s.user);
  const user = useLoginStore(s => s.user);
  const currentRole = useLoginStore(s => s.getCurrentRole)();
  const { organization, orgNavigate } = useOrganization();
  const playerId = currentUser.playerId;
  const playerRecord = user?.Players?.[0];
  const reloadCounter = useRequiredActionsStore(s => s.reloadCounter);
  const setRequiredActionsLoaded = useRequiredActionsStore(s => s.setRequiredActionsLoaded);
  const setCanIgnore = useRequiredActionsStore(s => s.setCanIgnore);
  const reloadShowNext = useRequiredActionsStore(s => s.reloadShowNext);
  const clearReloadShowNext = useRequiredActionsStore(s => s.clearReloadShowNext);
  const setModalOpen = useRequiredActionsStore(s => s.setModalOpen);
  const setRequiredActions = useRequiredActionsStore(s => s.setRequiredActions);

  const { data: playerRelationsData, reload: reloadSeasonPlayerRegistrations } = useFetchEntity(
    'Player', 
    currentRole === 'PLAYER' ? playerId : null, 
    'SeasonPlayerRegistrationsNotAccepted'
  );
  const seasonPlayerRegistrations = playerRelationsData?.SeasonPlayerRegistrationsNotAccepted;

  useEffect(() => {
    console.log(`Reloading required actions.. (counter: ${reloadCounter})`);
    reload();
  }, [reloadCounter]);

  function reload() {
    reloadSeasonPlayerRegistrations();
  }

  useEffect(() => {
    const requiredActions = [];
    let canIgnore = true;

    // Only process required actions if current role is Player
    if (currentRole === 'PLAYER' && playerRecord && seasonPlayerRegistrations) {
      // HMS-76: hrac cekajici na schvaleni (PREAPPROVED) muze registraci do souteze dokoncit i bez schvaleni
      const canReviewRegistrations = playerRecord?.status == 'ACTIVE' || (organization?.playerApprovalRequired && playerRecord?.status == 'PREAPPROVED');

      if (playerRecord?.status == 'INVITED') {
        requiredActions.push({
          text: <span><b>Action required: </b>Your player profile needs to be activated</span>,
          buttonText: 'Activate Now',
          buttonClick: () => orgNavigate('/player_profile'),
        });
        canIgnore = false;
      }
      if (seasonPlayerRegistrations?.length > 0) {
        requiredActions.push({
          text: <span><b>Action required: </b>You have been invited to participate in a competition. Please follow the link to review your participation.</span>,
          buttonText: 'Review Now',
          buttonClick: () => orgNavigate('/seasonplayerregistrations_player'),
          buttonDisabled: !canReviewRegistrations,
          buttonTooltip: !canReviewRegistrations ? 'You must be an ACTIVE player to review your registrations' : null,
          links: ['MyRegistrations'],
        });
      }
    }

    setRequiredActions(requiredActions);
    setCanIgnore(canIgnore);
    setRequiredActionsLoaded(true);

    if (reloadShowNext) {
      setModalOpen(true);
      clearReloadShowNext();
    }

  }, [currentRole, playerRecord, organization?.playerApprovalRequired, seasonPlayerRegistrations, clearReloadShowNext, orgNavigate, reloadShowNext, setCanIgnore, setModalOpen, setRequiredActions, setRequiredActionsLoaded]);
}

export default useRequiredActions